(function (tweetView, $) {
  var socialSection;
  var socialSectionHeight;
  var socialSectionOffsetTop;
  var twitterIcon;
  var isTouchDevice = Modernizr.touchevents;

  tweetView.init = function () {
    tweetView.view = $("#tweet-holder");
    if (tweetView.view.length <= 0) {
      return;
    }
    twitterIcon = $("#twitter-icon");
    socialSection = $("#social-section");
    calculateGeometry();

    setTimeout(calculateGeometry, 2000);
    setInterval(calculateGeometry, 8000);

    getLatestTweets();
    wireEvents();
  };

  function wireEvents() {
    el.documentElement.on("WINDOW_RESIZED_EVENT", function () {
      calculateGeometry();
    });

    if (!isTouchDevice) {
      el.documentElement.on("WINDOW_SCROLL_EVENT", function (evt, windowScrollTop) {
        var sectionOffset = windowScrollTop - socialSectionOffsetTop + el.windowHeight;
        if (el.windowWidth < 768 || sectionOffset < 0 || sectionOffset > socialSectionHeight * 2) {
          return;
        }

        twitterIcon.css({ x: sectionOffset / 5 - 200, y: -sectionOffset / 5 + 200 });
      });
    }
  }

  function calculateGeometry() {
    if (el.windowWidth >= 768) {
      socialSectionHeight = socialSection.outerHeight();
      socialSectionOffsetTop = socialSection.offset().top;
    }
  }

  function getLatestTweets() {
    $.ajax({
      url: "/data/tweets.json",
      type: "GET",
      dataType: "json",
      success: function (data) {
        if (!data) {
          return;
        }
        var tweetData = data;
        var tweets = [];
        $.each(tweetData, function (index, tweet) {
          if (tweet.in_reply_to_status_id || tweet.in_reply_to_screen_name) {
            // This is a public reply, we do not want to display it.
            return true; // continue in the loop
          }

          /*if(tweet.retweeted) {
					return true;
				}*/

          if (tweets.length > 6) {
            return false; // break, we have enough now!
          }

          var lastIndexOfTwitterLink = tweet.full_text.lastIndexOf("https://t.co/");
          if (lastIndexOfTwitterLink < 0) {
            lastIndexOfTwitterLink = tweet.full_text.lastIndexOf("http://t.co/");
          }
          if (lastIndexOfTwitterLink > 30) {
            tweet.full_text = tweet.full_text.substr(0, lastIndexOfTwitterLink);
          }

          if (tweet.retweeted_status && tweet.retweeted_status.full_text) {
            // if we don't do this, sometimes the URLs at the end of retweets are cut off and they don't work
            tweet.statusHtml = clean(
              "RT @" + tweet.retweeted_status.user.screen_name + ": " + tweet.retweeted_status.full_text,
              tweet.retweeted_status.entities.urls,
            );
          } else {
            tweet.statusHtml = clean(tweet.full_text, tweet.urls);
          }

          // if(tweet.entities && tweet.entities.media && tweet.entities.media.length > 0) {
          // 	tweet.imgUrl = tweet.entities.media[0].media_url_https;
          // } else if(tweet.retweeted_status && tweet.retweeted_status.extended_entities && tweet.retweeted_status.extended_entities.media && tweet.retweeted_status.extended_entities.media.length > 0) {
          //     tweet.imgUrl = tweet.retweeted_status.extended_entities.media[0].media_url_https;
          // } else {
          // 	return true; // only want tweets with pictures on the website!
          // }

          tweet.prettyDate = el.DateUtils.timeAgo(tweet.created_at);
          tweets.push(tweet);
        });

        var tweetsTemplate = $("#tweets-view-template").html();
        tweetsTemplate = _.template(tweetsTemplate);

        var tweetViewHtml = tweetsTemplate({ tweets: tweets });
        tweetView.view.html(tweetViewHtml);
      },
      error: function () {
        $.log("Failed to fetch tweets");
        setTimeout(getLatestTweets, 10000);
      },
    });
  }

  function at(tweet) {
    return tweet.replace(/\B[@＠]([a-zA-Z0-9_]{1,20})/g, function (m, username) {
      return (
        '<a target="_blank" class="twtr-atreply" href="http://twitter.com/intent/user?screen_name=' +
        username +
        '">@' +
        username +
        "</a>"
      );
    });
  }

  function list(tweet) {
    return tweet.replace(/\B[@＠]([a-zA-Z0-9_]{1,20}\/\w+)/g, function (m, userlist) {
      return '<a target="_blank" class="twtr-atreply" href="http://twitter.com/' + userlist + '">@' + userlist + "</a>";
    });
  }

  function hash(tweet) {
    return tweet.replace(/(^|\s+)#(\w+)/gi, function (m, before, hash) {
      return (
        before +
        '<a target="_blank" class="twtr-hashtag" href="http://twitter.com/search?q=%23' +
        hash +
        '">#' +
        hash +
        "</a>"
      );
    });
  }

  function clean(tweet, expandedUrls) {
    return hash(at(list(tweet, expandedUrls)));
  }
})((window.el.TweetView = window.el.TweetView || {}), jQuery);
